export const environment = {
  console: true,
  devUser : '',
  devPassword: '',
  ADMIN_AGENDA_URL: "http://admin.aljaferiaiacpospre.com/admin/Agenda.aspx",
  ADMIN_INDEX_URL: "http://admin.aljaferiaiacpospre.com/admin/MenuOperacionesEspeciales.aspx",
  API_URL: "https://apipre.apiacpos.com/2_16_0_bridge/",
  API_URL_TAQUILLA: "https://apipre.apiacpos.com/WebAPICoreBridge_1_8_0",
  CODIGO_APLICACION: "PVKORE",
  ID_APLICACION: "1",
  TPV_PATH: "TPVIAC",
  NUMSERIE:"TAQU$A$N0QBO3AQ0$A$ILLA$A$CVW1R9537",
  chClaveEmpresa: "ALJAFERIA",
  chEntornoConexion: "PREPRODUCCION",
  chNombreProyecto: "TAQUILLA",
  chOrigenConexion: "TAQUILLA",
  production: false,
  svgFolder: "development",
  API_TOKEN_USER: "admin@admin.com",
  API_TOKEN_PASSWORD: "IACPOS.2023a+",
  API_URL_MS: "https://apipre.apiacpos.com/WebAPICoreBridge_1_8_0"
};